<template>
  <div>
    <v-dialog
      v-model="approveVueDialog"
      persistent
      :max-width="contractCheckOutId ? '1200' : '900'"
      content-class="dialog-approve"
    >
      <v-card outlined>
        <v-card-title class="justify-between shadow info white--text">
          <div>
            {{
            isCreate
            ? text.isCreate + text.title
            : isUpdate
            ? text.isUpdate + text.title
            : "-"
            }}
          </div>
          <v-btn color="white" icon @click="approveVueDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text
          :class="`${!interestId?'dialog-approve-in overflow-y-auto': 'dialog-approve-in-def'} `"
          style="padding:0;"
        >
          <template v-if="interestId">
            <interest-form
              :objectId="interestId"
              :isUpdate="true"
              @onCancel="approveVueDialog = false"
              :value="value"
              :isView="true"
            ></interest-form>
          </template>
          <template v-if="contractCheckOutId">
            <div class="px-8 py-3">
              <v-overlay v-if="isLoading" color="white" absolute opacity="1">
                <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              </v-overlay>
              <Checkout1 :contractCheckOutId="contractCheckOutId" v-if="!isLoading" @onError="onError"/>
            </div>
            <CheckoutDialog
              v-model="isContractCheckOutDialog"
              :contractCheckOutId="contractCheckOutId"
              @onSaveSuccess="onContractCheckOutSaveSuccess"
              @onUpdateInvoice="onContractCheckOutSaveSuccess"
              @onError="onError"
              method="edit"
            />
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            v-if="contractCheckOutId"
            color="orange"
            class="mr-2 white--text"
            elevation="0"
            @click="isContractCheckOutDialog = true"
            :disabled="isLoading"
          >
            <v-icon left>mdi-pencil</v-icon>{{ $t('action_type.edit') }}
          </v-btn>
          <v-spacer></v-spacer>
          <div v-if="errorText">
            {{ $t('bill.checkout_bill_list') }} :
            <span class="text-red-500">{{errorText}}</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            class="mr-2"
            elevation="0"
            @click="preRejectApproveTask"
            :disabled="isLoading"
          >
            <v-icon left>mdi-window-close</v-icon>{{ $t('task.not_approve') }}
          </v-btn>
          <v-btn
            color="success"
            elevation="0"
            @click="preApproveApproveTask"
            :loading="isLoading"
            :disabled="isDisable || isLoading || isErrorBill"
          >
            <v-icon left>mdi-circle-outline</v-icon>{{ $t('task.approve') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      v-model="isReject"
      :loading="isLoading"
      :disabled="isLoading"
      :title="`${$t('task.not_approve')}`"
      :text="`${$t('task.you_want_to_not_approve')}`"
      :isNote="true"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="error"
      @onOk="rejectConfirmIn" />
    <ConfirmDialog
      :loading="isLoading"
      :disabled="isLoading"
      v-model="isApprove"
      :title="`${$t('task.approve')}`"
      :text="`${$t('task.you_want_to_approve')}`"
      :isNote="false"
      :textBtnOk="$t('confirm')"
      :textBtnCancel="$t('cancel')"
      type="success"
      @onOk="approveApproveTask()" />
  </div>
</template>

<script>
import ConfirmDialog from "./ConfirmDialog.component.vue";
import InterestForm from "./InterestForm.vue";
import Checkout1 from "./Checkout1.vue";
import CheckoutDialog from "./CheckoutDialog.vue";
import RenewContractForm from "./RenewContractForm.vue";
export default {
  components: {
    InterestForm,
    ConfirmDialog,
    Checkout1,
    CheckoutDialog,
    RenewContractForm
  },
  name: "ApproveVue",
  computed: {
    approveVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    approveTitle() {
      if (this.interestId) {
        return this.$t('task.approve_quotation');
      } else if (this.contractCheckOutId) {
        return this.$t('task.approve_checkout');
      } else {
        return this.$t('task.approve');
      }
    },
    approveDescription() {
      if (this.interestId) {
        return this.$t('task.want_to_approve_quotation');
      } else if (this.contractCheckOutId) {
        return this.$t('task.want_to_approve_checkout');
      } else {
        return this.$t('task.want_to_approve');
      }
    },
    rejectTitle() {
      if (this.interestId) {
        return this.$t('task.not_approve_quotation');
      } else if (this.contractCheckOutId) {
        return this.$t('task.not_approve_checkout');
      } else {
        return this.$t('task.not_approve');
      }
    },
    rejectDescription() {
      if (this.interestId) {
        return this.$t('task.want_to_approve_quotation');
      } else if (this.contractCheckOutId) {
        return this.$t('task.want_to_approve_checkout');
      } else {
        return this.$t('task.want_to_approve');
      }
    }
  },
  watch: {
    value(data) {
      if (data) {
        this.initData();
      }
    },
    errorText: {
      handler(text) {
        this.isErrorBill = text ? true : false;
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  data() {
    return {
      form: {},
      text: {
        title: this.$t('task.approve_list'),
        isCreate: this.$t('action_type.create'),
        isUpdate: ""
      },
      isLoading: false,
      isApprove: false,
      isReject: false,
      isContractCheckOutDialog: false,
      errorText: "",
      isErrorBill: false
    };
  },
  props: {
    value: Boolean,
    interestId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    approveId: String,
    contractCheckOutId: String,
    marketId: String,
    projectId: String
  },
  methods: {
    onError(text) {
      this.errorText = text;
    },
    preApproveApproveTask() {
      this.isApprove = true;
    },
    preRejectApproveTask() {
      this.isReject = true;
    },
    async initData() {
      try {
        const params = {};
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
      } catch (e) {
        console.log(e);
      }
    },
    onSave() {
      try {
        const response = this.saveData();
        this.approveVueDialog = false;
        this.$emit("onSave", response);
      } catch (e) {
        console.log(e);
      }
    },
    async approveApproveTask() {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "approveTask/approveApproveTask",
          {
            id: this.approveId
          }
        );
        if (response) {
          this.$toast.show({
            content: this.$t('task.approve_success'),
            color: "success"
          });
          this.$emit("onApproveTaskEvent", response);
          this.isReject = false;
          this.isApprove = false;
          this.approveVueDialog = false;
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        this.isReject = false;
        this.isApprove = false;
        if (error?.response?.data?.error) {
          this.$toast.show({
            content: error.response.data.error,
            color: "error"
          });
        } else {
          this.$toast.show({
            content: error.message,
            color: "error"
          });
        }
      }
    },

    async rejectApproveTask({ note }) {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "approveTask/rejectApproveTask",
          {
            id: this.approveId,
            cancelledNote: note
          }
        );
        if (response) {
          this.$toast.show({
            content: this.$t('task.reject_approve_success'),
            color: "success"
          });
          this.$emit("onApproveTaskEvent", response);
          this.isReject = false;
          this.isApprove = false;
          this.approveVueDialog = false;
          this.isLoading = false;
        }
      } catch (e) {
        console.log(e);
        this.isLoading = false;
        this.isReject = false;
        this.isApprove = false;
        this.$toast.show({
          content: e.message,
          color: "error"
        });
      }
    },
    onCancel() {
      try {
        this.approveVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
    onContractCheckOutSaveSuccess(contractCheckOut) {
      this.isLoading = true;
      setTimeout(() => {
        this.$forceUpdate();
        this.isLoading = false;
      }, 200);
    },
    async rejectConfirmIn({ note }) {
      await this.rejectApproveTask({ note });
    },
  }
};
</script>

<style lang="scss" scoped>
.dialog-approve.v-dialog .dialog-approve-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}
.dialog-approve-in-def.v-card__text::v-deep {
  min-height: 200px;
}
</style>
